import type { ViewerPluginName } from '@wix/ricos/schema-next';
import React from 'react';

import { Card } from './card';
import { ErrorBoundary } from './error-boundary';
import { Viewer } from './viewer';

export const ViewerCard: React.FC<{
  headerRightButtons?: React.ReactNode;
  headerCenter?: React.ReactNode;
  footer?: React.ReactNode;
  content: object;
  plugins: ViewerPluginName[];
  isMobile?: boolean;
}> = ({ headerRightButtons, headerCenter, footer, content, plugins, isMobile }) => {
  return (
    <Card
      backgroundColor={'#FFFFFF'}
      footer={footer}
      width="100%"
      header={{
        start: 'Viewer',
        center: headerCenter,
        end: headerRightButtons,
      }}
    >
      <ErrorBoundary>
        <Viewer isMobile={isMobile} content={content as any} plugins={plugins} />
      </ErrorBoundary>
    </Card>
  );
};
